import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from 'containers/Home/actions';
import * as customActions from './actions';
import Header from 'components/Header/Header';
import Navigation from 'components/Navigation/Navigation';
import Question from 'components/Question/Question';
import ScaleRadioButtonList from 'components/ScaleRadioButtonList/ScaleRadioButtonList';
import TextArea from 'components/TextArea/TextArea';
import './CustomQuestion.scss';

class CustomQuestion extends Component {
    constructor(props) {
        super(props);

        this.customPageNumber = parseInt(this.props.match.params.customPageNumber);
        this.numCustomPages = parseInt(this.props.match.params.numCustomPages);
        this.customQuestionType = '';
    }

    /**
     * Gets the Custom question specified by the position in the props. So, if the
     * position is 1 it will grab the first custom question, 2 the second, etc.
     */
    getCustomQuestion = () => {
        let customIndex = 0;

        for (const question of this.props.surveyData.OverallSubmission.OverallQuestions) {
            // Increment the custom question counter after each one we check.
            if (question.Type.toLowerCase().includes('custom question')) customIndex++;
            // If we find the question that matches the index, return it.
            if (customIndex === this.customPageNumber) return question;
        }
    }

    /**
     * Checks for any custom questions, and returns the link to the first
     * question, the next custom question, or to the overall additional page.
     */
    getNextPage = () => {
        // If we get to the last custom question (or somehow wind up
        // past it), then set the overall feedback page as next.
        if (this.customPageNumber === this.numCustomPages ||
            this.customPageNumber > this.numCustomPage) {
            return '/OverallAdditionalFeedback';
        } else {
            return `/CustomQuestion/${this.customPageNumber + 1}/${this.numCustomPages}`;
        }
    }

    /**
     * Checks for any custom questions, and returns the link to the previous 
     * custom question. When we get to the beginning, it return the TC page.
     */
    getPrevPage = () => {
        const isFirst = this.customPageNumber === 1;

        return isFirst ? '/TC' : `/CustomQuestion/${this.customPageNumber - 1}/${this.numCustomPages}`;
    }

	/**
	 * Called when there is a change to the text area value. Handles updating
	 * the text value state.
	 *
	 * @param {String} : comment
	 */
    handleChange = (comment) => {
        this.props.customActions.setOverallAnswer({
            type: this.customQuestionType,
            comment: comment
        });
    }

    render() {
        const { actions, customActions, individualID, match, prodTourID, surveyData } = this.props;
        this.customPageNumber = parseInt(match.params.customPageNumber);
        this.numCustomPages = parseInt(match.params.numCustomPages);
        const defaultTextValue = ''; // Use instead of null which does not cause a re-render.
        const nextLink = this.getNextPage();
        const prevLink = this.getPrevPage();
        const question = this.getCustomQuestion();
        const { Answer, SubText, Text, Type } = question;

        // Used to capture the question type that gets supplied to the reducer.
        this.customQuestionType = Type;

        return (
            <section className='wrapper custom'>
                {surveyData.IsBackup && (
                    <Header customerData={surveyData.Evaluator} isOverall={true} />
                )}

                <div className='container'>
                    <h1 className="stay-name">Overall <br /> Experience</h1>
                    
                    <div className='content'>
                        <Question questionText={Text || ''} />
						
                        <ScaleRadioButtonList
                            answerValue={Answer.AnswerRating}
                            handleClick={customActions.setOverallAnswer}
                            questionType={Type}
                        />

                        <Question questionText={SubText} />

                        <TextArea 
                            handleChange={this.handleChange} 
                            textValue={Answer.AnswerComment || defaultTextValue} 
                        />
            			
                        <Navigation
                            actions={actions}
                            answerValue={Answer.AnswerRating}
                            individualID={individualID}
                            isOverall={true}
                            locationIndex={3}
                            nextLink={nextLink} 
                            prevLink={prevLink} 
                            prodTourID={prodTourID}
                            surveyData={surveyData}
                        />
                    </div>
                </div>
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        individualID: state.dataReducer.individualID,
        prodTourID: state.dataReducer.prodTourID,
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        customActions: bindActionCreators(customActions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomQuestion));



// WEBPACK FOOTER //
// ./application/containers/CustomQuestion/CustomQuestion.jsx